import React, { useState } from 'react';
import GsecLetterModal from './GsecLetterModal';
import { canGenerateGsecLetter, getStoredUser } from '../utils/gsecLetterAccess';

/**
 * Print settlement instruction letter (final_approved deals only; back office + admin).
 */
const GsecLetterPrintButton = ({
  transaction,
  user: userProp,
  className = 'btn btn-sm btn-outline-primary',
  style,
  label = '🖨 Letter',
  title = 'View / Print settlement instruction letter',
}) => {
  const [selected, setSelected] = useState(null);
  const user = userProp || getStoredUser();

  if (!canGenerateGsecLetter(user, transaction)) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={className}
        style={style}
        onClick={() => setSelected(transaction)}
        title={title}
        aria-label="Print settlement instruction letter"
      >
        {label}
      </button>
      {selected && (
        <GsecLetterModal
          transaction={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </>
  );
};

export default GsecLetterPrintButton;
